<template>
    <div>
        <vx-tooltip :delay="tooltipDelay" :text="tooltipText" :tooltipPosition="tooltipPosition">
            <feather-icon icon="ShareIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="open"   v-if="data.StatusId == '0'" />
        </vx-tooltip>
        <vs-popup :title="popupTitle" :active.sync="active">
            <div>
                <vs-row class="mt-2">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="font-semibold">
                        <p>
                            {{ $t('confirm_action') }}
                        </p>
                    </vs-col>
                </vs-row>
                <vs-row vs-align="center" vs-type="flex" vs-justify="center" class="mt-5">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" class="mt-2 px-2">
                        <vs-button color="primary" type="filled" class="w-full" @click.prevent="submit"
                            :disabled="submitButtonText != $i18n.messages[$i18n.locale].submit">{{ submitButtonText
                            }}</vs-button>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" class="mt-2 px-2">
                        <vs-button color="primary" type="border" class="w-full" @click="close"
                            :disabled="submitButtonText != $i18n.messages[$i18n.locale].submit">{{ $t('cancel')
                            }}</vs-button>
                    </vs-col>
                </vs-row>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    props: {
        popupTitle: {
            type: String,
            default: 'title'
        },
        tooltipDelay: {
            type: String,
            default: '1.5s'
        },
        tooltipPosition: {
            type: String,
            default: 'top'
        },
        tooltipText: {
            type: String,
            default: null
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            active: false,
            submitButtonText: this.$i18n.messages[this.$i18n.locale].submit
        }
    },
    methods: {
        open() {
            this.active = true
        },
        close() {
            this.active = false
        },
        submit() {
            this.submitButtonText = this.$i18n.messages[this.$i18n.locale].loading + '...'
            let params = {
                invoiceId: this.data.InvoiceId,
            }
            this.$store.dispatch('invoice/publish', params)
            .then(res => {
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    text: 'Updated'
                })
                this.close()
                this.submitButtonText = this.$i18n.messages[this.$i18n.locale].submit
            })
            .catch(err => {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Oops...',
                    text: 'Something went wrong'
                })
                this.submitButtonText = this.$i18n.messages[this.$i18n.locale].submit
            })
        }
    }
}
</script>
